import { Height } from '@mui/icons-material'
import React, { useEffect } from 'react'

const Constitution = () => {
    const url = window.location;
    console.log(url);

    useEffect(() => {
      document.title = 'BSC Constitution | Bida Sport Club'
    }, [])
  return (
    <div className=' container card my-5 px-4'
    style={{ 
        height: `${window.innerWidth > 667 ? '85vh' : '60vh'}`
     }}
    >
        <h2 className='small-header ms-4 mt-4 text-center'>Bida Sport Club Members HandBook.</h2>
        <div 
        className='py-3'
        style={{ 
            height: `${window.innerWidth > 667 ? '85vh' : '60vh'}`
         }}>
            <iframe 
            src="https://docs.google.com/gview?url=https://uxtech.com.ng/bsc/files/pdf/constitution.pdf&embedded=true"
            // src='/constitution.pdf'
            width={'100%'} 
            height='99%'
            />
        </div>
    </div>
  )
}

export default Constitution